import React from "react";
import "./css/services.css"; // Ensure to create this CSS file for styles

const servicesData = [
  {
    title: "استشارات نفسية",
    description:
      "نقدم استشارات نفسية متخصصة للأطفال لمساعدتهم على التغلب على التحديات.",
    icon: "🧠", // You can replace this with an actual icon or image
  },
  {
    title: "دورات تعليمية",
    description:
      "دورات تعليمية متنوعة لتعزيز مهارات الأطفال في بيئة مشجعة.",
    icon: "📚",
  },
  {
    title: "دعم عائلي",
    description:
      "تقديم الدعم والمشورة للأسر لتوجيه أطفالهم نحو النجاح.",
    icon: "👨‍👩‍👧‍👦",
  },
  {
    title: "برامج تطوير شخصية",
    description:
      "برامج خاصة لتعزيز شخصية الأطفال وزيادة ثقتهم بأنفسهم.",
    icon: "✨",
  },
];

function Services() {
  return (
    <div className="services-container" data-aos="fade-up">
      <h2>خدماتنا</h2>
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
